import { Dialog } from '@opengov/component-library/dist';
import React from 'react';

import { ReportSvg } from '../../../icons/ReportSvg';
import { IReportLocale } from '../../../locale';

import styles from './ReportCreatingModal.scss';

export interface IReportCreatingMsgs {
  title: string;
}

export interface IReportCreatingModal {
  reportLocaleText: IReportLocale;
}

export const ReportCreatingModal: React.FC<IReportCreatingModal> = (props) => {
  const { reportLocaleText } = props;

  return (
    <Dialog.Info>
      <div className={styles.dialogContainer}>
        <ReportSvg />
        <h1 data-test="report-creating-modal-title">{reportLocaleText.create.modal.title}</h1>
      </div>
    </Dialog.Info>
  );
};
